import { supabase } from './supabase';
import { clearPendingReferralCode, getPendingCampaignSlug, getPendingReferralChannel, getPendingReferralCode } from './referralAttribution';

/** Link the signed-in user to a referrer (idempotent). */
export async function claimReferralCode(code: string | null | undefined): Promise<void> {
  const c = (code || '').trim().toUpperCase();
  if (!c || c.length < 4) return;
  try {
    const { error } = await supabase.rpc('claim_referral_code', { p_code: c });
    if (!error) {
      const campaign = getPendingCampaignSlug();
      const channel = getPendingReferralChannel();
      if (campaign) {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          await supabase.rpc('record_campaign_signup_for_user', {
            p_user_id: user.id,
            p_campaign_slug: campaign,
            p_channel: channel,
          });
        }
      }
      clearPendingReferralCode();
    }
  } catch {
    /* RPC may not exist until migration applied */
  }
}

export async function claimReferralForSessionUser(user: {
  user_metadata?: Record<string, unknown>;
  raw_user_meta_data?: Record<string, unknown>;
}): Promise<void> {
  const meta = user.user_metadata?.referral_code ?? user.raw_user_meta_data?.referral_code;
  const fromMeta = typeof meta === 'string' ? meta : null;
  const code = fromMeta || getPendingReferralCode();
  await claimReferralCode(code);
}
